import type { IntlShape } from "@formatjs/intl";
import type { AnyObject } from "antd/es/_util/type";
import { actions as routerActions } from "redux-router5";
import { Card } from "../../../common/components/Card.tsx";
import { NoData } from "../../../common/components/NoDataComp.tsx";
import {
  TableWrapper,
  type TableWrapperProps,
} from "../../../common/components/Table.tsx";
import * as commonColumns from "../../../common/columns.tsx";
import { routeNames } from "../../common/routes.ts";
import type { SideloadedTurbineInfo } from "../../../features/turbine/turbineSlice.ts";
import type {
  PaginatedturbineResultsSideloadList,
  Turbine,
} from "../../generated-axios-client/index.ts";

type LocationTurbinesProps = {
  intl: IntlShape;
  turbines: PaginatedturbineResultsSideloadList;
  turbineSideload: SideloadedTurbineInfo | null;
};

type rowDataType = {
  turbines: PaginatedturbineResultsSideloadList;
  turbineSideload: SideloadedTurbineInfo | null;
};

const getColumns: TableWrapperProps<rowDataType, AnyObject>["getColumns"] = (
  intl,
) => [
  commonColumns.simpleColumn(
    "serial_number",
    "turbine_table_column_serial_number",
    intl,
  ),
  commonColumns.simpleColumn(
    "park_number",
    "turbine_table_column_park_number",
    intl,
  ),
  commonColumns.simpleColumn("client", "turbine_table_column_client", intl),
  commonColumns.simpleColumn(
    "updated_at",
    "turbine_table_column_updated_at",
    intl,
  ),
  commonColumns.simpleColumn("actions", "table_column_actions", intl),
];

const getTableRows: TableWrapperProps<rowDataType, AnyObject>["getRows"] = (
  intl,
  dispatch,
  data,
) => {
  const { turbines, turbineSideload } = data;

  return Object.values(turbines.results.turbines).map((turbine: Turbine) => {
    const onView = () => {
      if (turbine.id) {
        dispatch(routerActions.navigateTo(routeNames.TURBINE_VIEW, { id: turbine.id }));
      }
    };

    return {
      key: turbine.id,
      serial_number: turbine.serial_number,
      park_number: turbine.park_number ?? <NoData intl={intl} />,
      client: turbineSideload?.client[turbine.client]?.legal_name,
      updated_at: turbine.updated_at ? (
        commonColumns.dateValue(turbine.updated_at, intl)
      ) : (
        <NoData intl={intl} />
      ),
      actions: commonColumns.actionsValue(
        undefined,
        undefined,
        turbine,
        undefined,
        onView,
        undefined,
        undefined,
        undefined,
        "Turbine",
      ),
    };
  });
};

export const LocationTurbinesInfo = ({
  intl,
  turbines,
  turbineSideload,
}: LocationTurbinesProps) => {
  const rowData: rowDataType = { turbines, turbineSideload };

  return (
    <Card title={intl.formatMessage({ id: "turbines" })}>
      <TableWrapper
        intl={intl}
        getColumns={getColumns}
        getRows={getTableRows}
        data={rowData}
        size="small"
      />
    </Card>
  );
};
